import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageTitles: Record<string, string> = {
    '/': 'Samuel John Band - Country Rock from Minnesota',
    '/band': 'Meet The Band - Samuel John Band',
    '/shows': 'Upcoming Shows - Samuel John Band',
    '/media': 'Photos & Media - Samuel John Band',
    '/contact': 'Contact Us - Samuel John Band',
    '/epk': 'Press Kit - Samuel John Band',
};

export function usePageTitle() {
    const location = useLocation();

    useEffect(() => {
        const title = pageTitles[location.pathname] || 'Samuel John Band';
        document.title = title;
    }, [location]);
}
